import type { TypedData, constants } from 'starknet';

const defaultTypedData = {
  primaryType: 'Message',
  types: {
    Message: [
      {
        name: 'message',
        type: 'felt',
      },
    ],
    StarkNetDomain: [
      {
        name: 'name',
        type: 'felt',
      },
      {
        name: 'chainId',
        type: 'felt',
      },
      {
        name: 'version',
        type: 'felt',
      },
    ],
  },
};

type FormatStarknetTypedDataMessageParams = {
  chainId: constants.StarknetChainId;
  inputMessage: string;
};

export const formatStarknetTypedDataMessage = ({
  inputMessage,
  chainId,
}: FormatStarknetTypedDataMessageParams): TypedData => {
  let nonce, domain;
  try {
    const { nonce: parsedNonce, domain: parsedDomain } =
      JSON.parse(inputMessage);
    nonce = parsedNonce;
    domain = parsedDomain;
  } catch {
    nonce = inputMessage;
    domain = 'domain';
  }

  // Starknet strings could be at most 31 chars long
  const message: Record<string, unknown> = {
    message: nonce.substring(0, 31),
  };

  return {
    ...defaultTypedData,
    domain: {
      chainId,
      name: domain.substring(0, 31),
      version: '0.0.1',
    },
    message,
  };
};
